
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-to-selong-belanak",
      function () {
        return require("private-next-pages/getting-to-selong-belanak.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-to-selong-belanak"])
      });
    }
  